/** Whether the person asks for reduced motion: no smooth scrolling or moving animation then. */
export function prefersReducedMotion(): boolean {
  return window.matchMedia("(prefers-reduced-motion: reduce)").matches;
}
